import { createContext, useContext, useEffect, useState } from "react";

const FavoritesContext = createContext();
const KEY = "ztm_favorites";

export const FavoritesProvider = ({ children }) => {
  const [favorites, setFavorites] = useState([]);

  useEffect(() => {
    try {
      const raw = localStorage.getItem(KEY);
      if (raw) setFavorites(JSON.parse(raw));
    } catch (e) {}
  }, []);

  const persist = (next) => {
    setFavorites(next);
    localStorage.setItem(KEY, JSON.stringify(next));
  };

  const isFavorite = (id) => favorites.some((f) => f.id === id);

  const toggleFavorite = (product) => {
    const exists = isFavorite(product.id);
    const next = exists
      ? favorites.filter((f) => f.id !== product.id)
      : [...favorites, {
          id: product.id, name: product.name, brand: product.brand, image: product.image,
          category: product.category, slug: product.slug, price: product.price,
          currency: product.currency, tags: product.tags, purity_score: product.purity_score,
        }];
    persist(next);
    return !exists;
  };

  const clearFavorites = () => persist([]);

  return (
    <FavoritesContext.Provider value={{ favorites, isFavorite, toggleFavorite, clearFavorites, count: favorites.length }}>
      {children}
    </FavoritesContext.Provider>
  );
};

export const useFavorites = () => useContext(FavoritesContext);
